import Vue from 'vue'
import store from './store/app'
import plugins from './plugins/app'
import './assets/sass/variables.scss'
import './pages/app'

if (process.env.NODE_ENV !== 'development') {
  const registerServiceWorker = require('./utils/sw/registration.js').default
  registerServiceWorker()
}

Vue.config.productionTip = false

window.$vm = new Vue({
  store,
  vuetify: plugins.vuetify,
  computed: {
    isDark() {
      return this.$store.getters['app/isDark']
    }
  },
  async created() {
    await this.$store.dispatch('app/getSite', site)
    this.$vuetify.theme.dark = this.isDark
  }
}).$mount('#app')
